import request from "@/utils/request";

// 收藏或取消点赞
export const  addOrCancelLike =(query) =>{
    return request({
        url: "/businessservice/likes/addOrCancel",
        method:"get",
        params: query
    })
}

// 判断是否点赞
export const  judgeIsLike =(query) =>{
    return request({
        url: "/businessservice/likes/judgeIsLike",
        method:"get",
        params: query
    })
}
